import { render, staticRenderFns } from "./OpenBarrierPopup.vue?vue&type=template&id=47b48374&scoped=true"
import script from "./OpenBarrierPopup.vue?vue&type=script&lang=ts"
export * from "./OpenBarrierPopup.vue?vue&type=script&lang=ts"
import style0 from "./OpenBarrierPopup.vue?vue&type=style&index=0&id=47b48374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b48374",
  null
  
)

export default component.exports